import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContratoLocacionDTO } from 'src/app/models/location-contract';
import { ErrorResponse } from 'src/app/models/error.model';
import { ContractsService } from 'src/app/services/contracts.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DocumentsService } from 'src/app/services/documents.service';
import { ID } from 'src/app/models/ID.model';

@Component({
    selector: 'app-contract-details',
    templateUrl: './contract-details.component.html',
    styleUrls: ['./contract-details.component.scss']
})
export class ContractDetailsComponent implements OnInit {

    contratoDTO?: ContratoLocacionDTO;
    loading = false;
    error?: string;
    descargandoPDF = false;
    descargandoDOCX = false;

    private contratoId: number;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private contractsService: ContractsService,
        private utilsService: UtilsService,
        private documentsService: DocumentsService,
    ) {
        // Obtener ID del contrato desde la ruta
        this.contratoId = +this.route.snapshot.params['id'];
    }

    ngOnInit(): void {
        if (this.contratoId) {
            this.loadContract();
        } else {
            this.error = 'ID de contrato no válido';
        }
    }

    /**
     * Carga los detalles del contrato desde el backend
     */
    loadContract(): void {
        this.loading = true;
        this.error = undefined;

        this.contractsService.getContractById(this.contratoId).subscribe({
            next: (contrato: ContratoLocacionDTO) => {
                this.loading = false;
                this.contratoDTO = contrato;
                console.log('Contrato cargado:', contrato);
            },
            error: (error: ErrorResponse) => {
                this.loading = false;
                this.error = error.error?.descripcion || 'Error al cargar el contrato';
                this.utilsService.alert('Error', this.error);
            }
        });
    }

    /**
     * Obtiene la etiqueta legible de la forma de pago
     */
    getFormaDePagoLabel(formaPago: string): string {
        const formas: { [key: string]: string } = {
            'EfectivoAlLocador': 'Efectivo al locador',
            'EfectivoenInmobiliaria': 'Efectivo en inmobiliaria',
            'TransferenciaCBU': 'Transferencia bancaria',
            'DepositoBancario': 'Depósito bancario'
        };
        return formas[formaPago] || formaPago;
    }

    downloadDocument(documentId: ID) {
        this.documentsService.downloadContract(documentId).subscribe(({ blob }) => {
            this.utilsService.downloadBlobAsFile(blob, 'locacion-' + this.contratoDTO.contratoId.toString());
        }, (error: ErrorResponse) => this.utilsService.alert('Error al descargar archivo', error.error?.descripcion));
    }

    /**
     * Descarga el PDF del contrato
     */
    downloadPDF(): void {
        this.downloadDocument(this.contratoDTO.documentoPDFId);
    }

    /**
     * Descarga el DOCX del contrato
     */
    downloadDOCX(): void {
        this.downloadDocument(this.contratoDTO.documentoDOCXId);
    }

    /**
     * Helper para descargar archivos
     */
    private downloadFile(blob: Blob, filename: string): void {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}